import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const MentionsLegalesPage = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-[#F8FAFC] py-16" data-testid="mentions-hero">
        <div className="container-custom">
          <motion.div 
            className="max-w-3xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link 
              to="/"
              className="inline-flex items-center gap-2 text-[#1997b0] hover:underline mb-6"
              data-testid="mentions-back"
            >
              <ArrowLeft size={18} />
              Retour à l'accueil
            </Link>
            <h1 className="font-outfit text-4xl md:text-5xl font-bold text-[#000000] mb-4">
              Mentions légales
            </h1>
            <p className="text-slate-600">
              Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance 
              en l'économie numérique, il est précisé aux utilisateurs du site ADM Confort Clim 
              l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="section-padding bg-white" data-testid="mentions-content">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-slate">
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                1. Informations légales
              </h2>
              <div className="bg-[#F8FAFC] p-6 rounded-xl">
                <p className="text-slate-600 mb-4">
                  <strong className="text-[#000000]">Raison sociale :</strong> ADM Confort Clim
                </p>
                <p className="text-slate-600 mb-4">
                  <strong className="text-[#000000]">SIRET :</strong> 94406926900016
                </p>
                <p className="text-slate-600 mb-4">
                  <strong className="text-[#000000]">Siège social :</strong> 209 rue de Changis, 77550 Moissy-Cramayel, France
                </p>
                <p className="text-slate-600 mb-4">
                  <strong className="text-[#000000]">Téléphone :</strong> 06 03 05 49 11
                </p>
                <p className="text-slate-600 mb-4">
                  <strong className="text-[#000000]">Email :</strong> admconfortclim@gmail.com
                </p>
                <p className="text-slate-600 mb-4">
                  <strong className="text-[#000000]">Site web :</strong> admconfortclim.fr
                </p>
                <p className="text-slate-600">
                  <strong className="text-[#000000]">Activité :</strong> Climaticien et frigoriste - Installation, maintenance et dépannage de climatisation, pompe à chaleur, froid commercial et ventilation
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                2. Directeur de la publication
              </h2>
              <p className="text-slate-600">
                Le directeur de la publication du site est ADM Confort Clim, joignable à l'adresse 
                email : admconfortclim@gmail.com
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                3. Hébergement
              </h2>
              <p className="text-slate-600">
                Le site ADM Confort Clim est hébergé par un prestataire professionnel garantissant 
                la disponibilité et la sécurité des données.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                4. Propriété intellectuelle
              </h2>
              <p className="text-slate-600 mb-4">
                L'ensemble du contenu du site ADM Confort Clim (textes, images, graphismes, logo, 
                icônes, etc.) est la propriété exclusive d'ADM Confort Clim, à l'exception des 
                marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.
              </p>
              <p className="text-slate-600">
                Toute reproduction, représentation, modification, publication, adaptation totale 
                ou partielle des éléments du site, quel que soit le moyen ou le procédé utilisé, 
                est interdite, sauf autorisation écrite préalable d'ADM Confort Clim.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                5. Protection des données personnelles
              </h2>
              <p className="text-slate-600 mb-4">
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la 
                loi Informatique et Libertés du 6 janvier 1978 modifiée, vous disposez des droits 
                suivants concernant vos données personnelles :
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-2">
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit à la portabilité</li>
                <li>Droit d'opposition</li>
              </ul>
              <p className="text-slate-600">
                Pour exercer ces droits, vous pouvez nous contacter à l'adresse : 
                admconfortclim@gmail.com
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                6. Cookies
              </h2>
              <p className="text-slate-600 mb-4">
                Le site ADM Confort Clim peut utiliser des cookies pour améliorer l'expérience 
                utilisateur et à des fins statistiques. Les cookies sont de petits fichiers 
                stockés sur votre ordinateur qui permettent de mémoriser vos préférences.
              </p>
              <p className="text-slate-600">
                Vous pouvez configurer votre navigateur pour refuser les cookies ou être 
                averti lorsqu'un cookie est envoyé.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                7. Limitation de responsabilité
              </h2>
              <p className="text-slate-600 mb-4">
                ADM Confort Clim s'efforce de fournir sur le site des informations aussi 
                précises que possible. Toutefois, ADM Confort Clim ne pourra être tenu 
                responsable des omissions, des inexactitudes et des carences dans la mise 
                à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui 
                lui fournissent ces informations.
              </p>
              <p className="text-slate-600">
                Toutes les informations indiquées sur le site sont données à titre indicatif 
                et sont susceptibles d'évoluer. Par ailleurs, les informations contenues sur 
                ce site ne sont pas exhaustives. Elles sont données sous réserve de 
                modifications ayant été apportées depuis leur mise en ligne.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                8. Liens hypertextes
              </h2>
              <p className="text-slate-600">
                Le site ADM Confort Clim peut contenir des liens hypertextes vers d'autres 
                sites. Cependant, ADM Confort Clim n'a pas la possibilité de vérifier le 
                contenu des sites ainsi visités et n'assumera en conséquence aucune 
                responsabilité de ce fait.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mb-12"
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                9. Droit applicable
              </h2>
              <p className="text-slate-600">
                Tout litige en relation avec l'utilisation du site ADM Confort Clim est 
                soumis au droit français. L'utilisateur reconnaît la compétence exclusive 
                des tribunaux compétents de Melun.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="font-outfit text-2xl font-bold text-[#000000] mb-4">
                10. Contact
              </h2>
              <p className="text-slate-600 mb-4">
                Pour toute question relative aux présentes mentions légales ou pour toute 
                demande concernant le site, vous pouvez nous contacter :
              </p>
              <div className="bg-[#F8FAFC] p-6 rounded-xl">
                <p className="text-slate-600 mb-2">
                  <strong className="text-[#000000]">Par téléphone :</strong> 06 03 05 49 11
                </p>
                <p className="text-slate-600 mb-2">
                  <strong className="text-[#000000]">Par email :</strong> admconfortclim@gmail.com
                </p>
                <p className="text-slate-600">
                  <strong className="text-[#000000]">Par courrier :</strong> ADM Confort Clim - 209 rue de Changis, 77550 Moissy-Cramayel
                </p>
              </div>
            </motion.div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegalesPage;
